// extracted by mini-css-extract-plugin
module.exports = {"toast":"GpcToast_toast__aGD44"};